// src/services/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    isLogin: false,
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload; // Set user data
      state.isLogin = true; // Set isLogin to true
    },
    logout(state) {
      state.user = null; // Clear user data
      state.isLogin = false; // Set isLogin to false
    },
  },
});

export const { setUser, logout } = authSlice.actions;
export default authSlice.reducer;
